var _rect, _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 328,
    viewBox: "0 0 336 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 328,
    fill: "#F9FAFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2239_35828)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.226 78H122C119.791 78 118 79.7909 118 82V208.744C118 210.953 119.791 212.744 122 212.744H213.381C215.59 212.744 217.381 210.953 217.381 208.744V107.002L188.226 78Z",
    fill: "#C2C1D5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.471 109.005H174.346V100.917H135.471V109.005Z",
    fill: "#A6A5C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.471 138.003H198.68V129.915H135.471V138.003Z",
    fill: "#A6A5C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.471 156.3H198.68V148.211H135.471V156.3Z",
    fill: "#A6A5C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.471 174.595H198.68V166.508H135.471V174.595Z",
    fill: "#9695BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.471 192.892H198.68V184.805H135.471V192.892Z",
    fill: "#9695BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.381 136.121L188.226 107.119L202.863 92.5591L217.381 107.002V136.121Z",
    fill: "#B6B6CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.225 107.002H217.381L188.225 78V107.002Z",
    fill: "#E1E1EA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.8 275.4C138.587 275.4 138.395 275.325 138.224 275.176C138.075 275.005 138 274.813 138 274.6V253.8C138 253.565 138.075 253.373 138.224 253.224C138.395 253.075 138.587 253 138.8 253H147.76C150.491 253 152.635 253.629 154.192 254.888C155.771 256.147 156.56 257.981 156.56 260.392C156.56 262.781 155.781 264.584 154.224 265.8C152.667 266.995 150.512 267.592 147.76 267.592H143.952V274.6C143.952 274.835 143.867 275.027 143.696 275.176C143.547 275.325 143.355 275.4 143.12 275.4H138.8ZM147.6 263.176C148.539 263.176 149.275 262.941 149.808 262.472C150.341 261.981 150.608 261.267 150.608 260.328C150.608 259.453 150.352 258.76 149.84 258.248C149.349 257.715 148.603 257.448 147.6 257.448H143.856V263.176H147.6Z",
    fill: "#6E6CB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.425 275.4C160.212 275.4 160.02 275.325 159.849 275.176C159.7 275.005 159.625 274.813 159.625 274.6V253.8C159.625 253.565 159.7 253.373 159.849 253.224C160.02 253.075 160.212 253 160.425 253H168.745C171.881 253 174.313 253.747 176.041 255.24C177.769 256.733 178.676 258.899 178.761 261.736C178.782 262.355 178.793 263.176 178.793 264.2C178.793 265.224 178.782 266.035 178.761 266.632C178.654 269.597 177.769 271.805 176.105 273.256C174.462 274.685 172.062 275.4 168.905 275.4H160.425ZM168.745 270.792C170.153 270.792 171.188 270.461 171.849 269.8C172.51 269.117 172.862 268.04 172.905 266.568C172.948 265.949 172.969 265.149 172.969 264.168C172.969 263.187 172.948 262.397 172.905 261.8C172.862 260.371 172.478 259.315 171.753 258.632C171.049 257.949 169.993 257.608 168.585 257.608H165.385V270.792H168.745Z",
    fill: "#6E6CB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.331 275.4C183.118 275.4 182.926 275.325 182.755 275.176C182.606 275.005 182.531 274.813 182.531 274.6V253.8C182.531 253.565 182.606 253.373 182.755 253.224C182.926 253.075 183.118 253 183.331 253H198.051C198.286 253 198.478 253.075 198.627 253.224C198.777 253.373 198.851 253.565 198.851 253.8V257.032C198.851 257.245 198.777 257.437 198.627 257.608C198.478 257.757 198.286 257.832 198.051 257.832H188.163V262.536H197.411C197.646 262.536 197.838 262.621 197.987 262.792C198.137 262.941 198.211 263.133 198.211 263.368V266.568C198.211 266.781 198.137 266.973 197.987 267.144C197.838 267.293 197.646 267.368 197.411 267.368H188.163V274.6C188.163 274.835 188.089 275.027 187.939 275.176C187.79 275.325 187.598 275.4 187.363 275.4H183.331Z",
    fill: "#6E6CB2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2239_35828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 135,
    fill: "white",
    transform: "translate(118 78)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.4ace228d5b3fd7d1ad01e2ef6e57a765.svg";
export { ForwardRef as ReactComponent };